module.exports = __webpack_public_path__ + "img/400_Ransomware.65bfe75f.png";